var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequestsRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.30667V21.3333C24 22.8 22.92 24 21.6 24H2.4C1.08 24 0 22.8 0 21.3333V5.33333C0 3.86667 1.08 2.66667 2.4 2.66667H14.52C14.448 3.09333 14.4 3.54667 14.4 4C14.4 5.97333 15.18 7.72 16.404 8.94667L12 12L2.4 5.33333V8L12 14.6667L18.36 10.24C19.008 10.5067 19.68 10.6667 20.4 10.6667C21.756 10.6667 22.992 10.1467 24 9.30667ZM16.8 4C16.8 6.21333 18.408 8 20.4 8C22.392 8 24 6.21333 24 4C24 1.78667 22.392 0 20.4 0C18.408 0 16.8 1.78667 16.8 4Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestsRed);
export default __webpack_public_path__ + "static/media/RequestsRed.5f29d7bc98edf51d161a13d0ca46a255.svg";
export { ForwardRef as ReactComponent };